import _ from 'lodash';
import { fiflboxApi } from '@/utils/api';

const state = {
  parentMemberships: [],
  parentMembershipCategories: []
};

const mutations = {
  setParentMembershipCategories(state, parentMembershipCategories) {
    state.parentMembershipCategories = parentMembershipCategories;
  },
  setParentMemberships(state, parentMemberships) {
    state.parentMemberships = parentMemberships;
  }
};

const getters = {
  getParentMembershipCategories: state => {
    return state.parentMembershipCategories;
  },
  getParentMembershipCategory: state => categoryId => {
    return state.parentMembershipCategories.find(
      category => category.id === categoryId
    );
  },
  getParentMemberships: state => {
    return state.parentMemberships;
  },
  getParentMembershipsInKeys: state => {
    return _.keyBy(state.parentMemberships, 'id');
  },
  getParentMembershipForFilterBox: state => {
    return state.parentMemberships
      .map(membership => {
        return {
          text: `${membership.is_removed ? '(삭제)' : ''}${membership.name}`,
          value: membership.id
        };
      })
      .sort((before, after) => {
        const isBeforeMembershipDeleted = before.text.includes('(삭제)');
        const isAfterMembershipDeleted = after.text.includes('(삭제)');
        if (isBeforeMembershipDeleted && !isAfterMembershipDeleted) {
          return 1;
        }
        if (!isBeforeMembershipDeleted && isAfterMembershipDeleted) {
          return -1;
        }
        return 0;
      });
  },
  getParentMembershipForSelectBox: state => {
    const { parentMemberships, parentMembershipCategories } = state;

    const [removedMemberships, aliveMemberships] = _.partition(
      parentMemberships,
      'is_removed'
    );

    const categories = parentMembershipCategories.map(category => {
      const options = aliveMemberships
        .filter(membership => membership.category === category.id)
        .map(membership => {
          return {
            label: membership.name,
            value: membership.id,
            is_removed: membership.is_removed
          };
        });

      return {
        label: category.name,
        options
      };
    });

    const removedCategory = {
      label: '삭제된 회원권',
      options: removedMemberships.map(membership => {
        return {
          label: membership.name,
          value: membership.id,
          is_removed: membership.is_removed
        };
      })
    };

    return [...categories, removedCategory];
  }
};

const actions = {
  async syncParentMemberships({ commit }) {
    let {
      data: parentMemberships
    } = await fiflboxApi.v2.getParentMemberships();
    commit('setParentMemberships', parentMemberships);
  },
  async syncParentMembershipCategories(
    { commit },
    payload = { is_removed: false }
  ) {
    let {
      data: parentMembershipCategories
    } = await fiflboxApi.v2.getMembershipCategories(payload);

    commit('setParentMembershipCategories', parentMembershipCategories);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
